import React from 'react';

export function getOperationEntry(om, opPath, instanceIdx, page) {
  if (!om || typeof om !== 'object' || !opPath) return null;
  const keys = opPath.split('.');
  let cur = om;
  for (const k of keys) {
    if (!cur || typeof cur !== 'object') return null;
    cur = cur[k];
  }
  if (cur === null || cur === undefined) return null;
  if (Array.isArray(cur)) {
    if (typeof instanceIdx !== 'number') return null;
    if (typeof page === 'number') {
      const taggedAtAll = cur.some((it) => it && typeof it._page_number === 'number');
      if (taggedAtAll) {
        const pageItems = cur.filter((it) => it && it._page_number === page);
        return pageItems[instanceIdx] || null;
      }
    }
    return cur[instanceIdx] || null;
  }
  return cur;
}

export function formatValue(v) {
  if (v === null || v === undefined || v === '') return '—';
  if (typeof v === 'boolean') return v ? 'sí' : 'no';
  return String(v);
}

export function splitOpPath(opPath) {
  const parts = opPath.split('.');
  return { category: parts[0], subPath: parts.slice(1).join('.') };
}

const DetectionMatchBlock = ({ match, operacionesMecanizado, overrideFields, onEdit, onReject }) => {
  const isProvisional = !!match._provisional;
  const resolvedEntry = isProvisional && overrideFields && Object.keys(overrideFields).length > 0
    ? overrideFields
    : getOperationEntry(operacionesMecanizado, match.op_path, match.instance_idx, match.page);
  const entry = resolvedEntry;
  const { category, subPath } = splitOpPath(match.op_path);
  const indexLabel = !isProvisional && typeof match.instance_idx === 'number' ? `#${match.instance_idx + 1}` : null;

  const handleCardClick = (e) => {
    if (e.target.closest('.match-card-close')) return;
    if (onEdit) onEdit();
  };

  const handleReject = (e) => {
    e.stopPropagation();
    if (onReject) onReject();
  };

  const cardClass = `match-card${onEdit ? ' is-clickable' : ''}`;

  if (!entry || typeof entry !== 'object') {
    return (
      <div className={`${cardClass} match-card-empty`} onClick={handleCardClick} title={onEdit ? 'Editar asignación' : ''}>
        <span className="match-category">{category}</span>
        {subPath && <span className="match-subpath">{subPath}</span>}
        {onReject && (
          <button className="match-card-close" onClick={handleReject} title="Rechazar este match">×</button>
        )}
      </div>
    );
  }

  const paramKeys = Object.keys(entry).filter((k) => !k.startsWith('_'));

  return (
    <div className={cardClass} onClick={handleCardClick} title={onEdit ? 'Editar asignación' : ''}>
      <div className="match-card-header">
        <span className="match-category">{category}</span>
        {subPath && <span className="match-subpath">{subPath}</span>}
        {indexLabel && <span className="match-index">{indexLabel}</span>}
        {onReject && (
          <button className="match-card-close" onClick={handleReject} title="Rechazar este match (no volverá a aparecer)">×</button>
        )}
      </div>
      <div className="match-card-params">
        {paramKeys.map((k) => {
          const isHighlighted = k === match.param;
          return (
            <div
              key={k}
              className={`match-param-chip ${isHighlighted ? 'is-highlighted' : ''}`}
              title={isHighlighted ? 'Parámetro aportado por esta detección' : ''}
            >
              <span className="match-param-key">{k}</span>
              <span className="match-param-value">{formatValue(entry[k])}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DetectionMatchBlock;
